export default __webpack_public_path__ + "static/media/A6.03b852af.png";